import React from 'react';


import SubmitProductForm from 'views/designer/SubmitProductForm';
import SetoCanvasPage from 'pages/SetoCanvasPage';

import HeaderBanner from 'views/HeaderBanner';
import {A, Separator} from 'views/AppElements';

import AppConstants from 'AppConstants';

class SubmitDesignPage extends React.Component {
	render() {
		const productTypes = AppConstants.PRODUCT_TYPES;

		const psdTemplates = Object.keys(productTypes)
									.map(k => productTypes[k])
									.filter(p => p.available === true && p.psdTemplateUrl !== undefined && p.psdTemplateUrl !== null && p.psdTemplateUrl.length > 0)
									.map(p => {
										return <li key={p.label+"-psd-template"}><A href={p.psdTemplateUrl}>{p.label}.psd</A></li>;
									});

		return (
				<SetoCanvasPage id="submitDesignPage" title="Submit your Design and Start Earning From Home | Seto Canvas"
								metaDescription="Seto Canvas is a marketplace for Designers to sell their art printed on merchandise like TShirts, Mugs, Pillows and more.">
					
					<HeaderBanner bannerImages={[
						{"img": "/images/banners/hga-campaign/HGA Contest Banner.jpeg", "title": "High Ground Adventure Design Contest at setocanvas.com", "url": "/high-ground-adventure-design"},
						{img: "/images/banners/submit_design_banner.jpg", title: "Submit your design at setocanvas.com"},
													{img: "/images/banners/photographer_banner.png", title: "Submit your photograph at setocanvas.com"}]} />

					<div className="flexRow" style={{margin: '10px 0 20px 0px', justifyContent: 'space-evenly'}}>
						
						<SubmitProductForm />

						<div className="flexColumn">
							<div id="designTemplates">
								<h3>Product Templates</h3>
								<span>Use the template to put your design on a T-Shirt or a Hoodie.</span>
								<ul>
									{psdTemplates}
								</ul>
							</div>
							<Separator />
							<div id="designerDocs">
								<h3>Documents</h3>
								<ul>
									<li><A href="/how-to-make-money">How does Seto Canvas works?</A></li>
									<li><A href="/how-much-can-i-make">How much can I make?</A></li>
									<li><A href="/faq#tshirtDesignLimitation">What kind of designs are supported on Tshirts?</A></li>
									<li><A href="/faq#hoodiesDesignLimitation">What kind of designs are supported on Hoodies?</A></li>
									<li><A href="/faq#designerFAQ">FAQ For Designers</A></li>
									<li><A href="/faq#photographerFAQ">FAQ For Photographers</A></li>
								</ul>
							</div>
							<Separator />
							<div id="fbGroup">
								<h3>Design Heroes Group</h3>
								<div className="flexColumn">
									<A id="joinFBGroupBtn" href={AppConstants.FB_GROUP}>
										<i className="fa fa-facebook-official" aria-hidden="true"></i> Join our Facebook Group of Artist</A>
								</div>
							</div>
						</div>
					</div>
					
				</SetoCanvasPage>
			);
		
	}
}


export default SubmitDesignPage;


// WEBPACK FOOTER //
// ./src/pages/SubmitDesignPage.js